import { useLocation } from '@tanstack/react-router';

/**
 * Hook to check if the current location matches a given path
 */
export const useLocationMatch = () => {
  const location = useLocation();

  /**
   * Check if the current location ends with the given path
   */
  const hasMatch = (path?: string) => (path ? location.href.endsWith(path) : false);

  /**
   * Check if the current location is an exact match with the given path
   */
  const hasExactMatch = (path?: string) => (path ? location.href === path : false);

  /**
   * Check if the current location contains the given path
   */
  const hasPartialMatch = (path?: string) => (path ? location.href.includes(path) : false);

  return { hasMatch, hasExactMatch, hasPartialMatch };
};
